(function () {
  function cookie(name) {
    var match = document.cookie.match(
      new RegExp("(?:^|; )" + name.replace(/[.*+?^$(){}|[\]\\]/g, "\\$&") + "=([^;]*)")
    );
    return match ? decodeURIComponent(match[1]) : "";
  }

  function landingUrl() {
    try {
      var href = location.href;
      if (/fbclid=|wacid=|waid=|wasid=|gclid=|ttclid=|utm_source=/.test(href)) {
        return href;
      }
    } catch (error) {}
    return "";
  }

  function persist() {
    var wuid = cookie("_wuid");
    if (!wuid) return;

    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var attrs = cart.attributes || {};
        var next = {
          _wuid: wuid,
          _fbp: cookie("_fbp") || attrs._fbp || "",
          _fbc: cookie("_fbc") || attrs._fbc || "",
          _whop_landing: attrs._whop_landing || landingUrl()
        };
        var changed =
          String(attrs._wuid || "") !== String(next._wuid) ||
          String(attrs._fbp || "") !== String(next._fbp) ||
          String(attrs._fbc || "") !== String(next._fbc) ||
          String(attrs._whop_landing || "") !== String(next._whop_landing);
        if (!changed) return;
        return fetch("/cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes: Object.assign({}, attrs, next) })
        });
      })
      .catch(function () {});
  }

  persist();
  setTimeout(persist, 2000);
})();
